import React from "react";
import { Link } from "react-router-dom";
import { FiHome } from "react-icons/fi";
import logo from "../assets/logo-Photoroom.png";

const AuthHeader = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#1C1F2E]/90 backdrop-blur-xl border-b border-gray-700/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center group"
            aria-label="Go to home page"
          >
            <div className="h-10 sm:h-12 flex items-center transition-all duration-300 group-hover:scale-105">
              <img
                src={logo}
                alt="Viszapp Logo"
                className="h-full object-contain"
                style={{ maxWidth: "150px" }}
              />
            </div>
          </Link>

          {/* Right side - Back to Home link */}
          <Link
            to="/"
            className="flex items-center gap-2 px-4 py-2 rounded-lg
                     text-sm sm:text-base text-gray-300 
                     bg-white/5 hover:bg-white/10 border border-gray-700/50
                     hover:border-teal-500/50 hover:text-teal-400 
                     transition-all duration-300 group"
          >
            <FiHome className="w-4 h-4 sm:w-5 sm:h-5 transition-transform duration-300 group-hover:scale-110" />
            <span className="hidden sm:inline font-medium">Back to Home</span>
            <span className="sm:hidden font-medium">Home</span>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default AuthHeader;